import { ComponentProps, PropsWithChildren, useMemo } from 'react'
import Styles from './AlertContainer.module.scss'
import { t } from 'translate/i18n'
import IconRarum from 'components/IconRarum'
import { LPTypo } from 'containers/OneUIProvider/OneUIProvider.data'
import Text from '@onepercentio/one-ui/components/Text'

/**
 * Displays a highlighted message to warn the user of some complementary information
 **/
export default function AlertContainer({
  type,
  children,
  noTitle,
  title,
}: PropsWithChildren<{ type: 'warning'; noTitle?: boolean; title?: string }>) {
  const [icon, defaultTitle] = useMemo<
    [ComponentProps<typeof IconRarum>['icon'], string]
  >(() => {
    switch (type) {
      case 'warning':
        return ['alert', t('generic.attention')]
    }
  }, [type])
  return (
    <div className={Styles[type]}>
      {!noTitle && (
        <div className={Styles.title}>
          <IconRarum icon={icon} size={16} />
          <Text type={LPTypo.P1Bold}>{title || defaultTitle}</Text>
        </div>
      )}
      <div>{children}</div>
    </div>
  )
}
